import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { problems } from '../data/salesContent';
export function ProblemSection() {
  return <section className="bg-mist py-16 lg:py-24" data-id="element-146" data-mp="2lu4mzfde3g5n">
      <div className="mx-auto max-w-5xl px-5" data-id="element-147" data-mp="30hprndpwxnfo">
        <h2 className="mx-auto max-w-3xl text-center font-display text-3xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-148" data-mp="30iiq7repx6mq">
          Own a Pool—but Still Feel Unsure About Caring for It?
        </h2>
        <ul className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-149" data-mp="39jz07y1mf6qf">
          {problems.map(problem => <li key={problem} className="flex items-start gap-4 rounded-2xl border border-line bg-white p-5 sm:p-6" data-id="element-150" data-mp="35idfjqiuho5o">
              <HelpCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-aqua" aria-hidden="true" data-id="element-151" data-mp="3ei0iigr8320u" />
              <p className="text-lg font-medium leading-snug text-navy" data-id="element-152" data-mp="1p199hcmz4sp4">{problem}</p>
            </li>)}
        </ul>
        <p className="mx-auto mt-10 max-w-2xl text-center text-lg leading-relaxed text-ink" data-id="element-153" data-mp="1k4it0o79bv36">
          <strong className="font-semibold text-navy" data-id="element-154" data-mp="jeetatcxvtl6">Pool Care Made Simple</strong> gives you a
          practical place to start and a clear process to follow.
        </p>
      </div>
    </section>;
}